import { AfterViewInit, Component, OnDestroy, signal, ViewChild, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';

import { AppState } from '../../../../app.state';
import { TableCellDescriptor } from '../../../../model.module/table-cell.model';
import { SortType } from '../../../../model.module/constant/sort-types.enum';
import { FilterFunctions } from '../../../../pipes.module/_filter.functions';
import { SuperComponent } from '../../../inside.super';
import { Subscription, take } from 'rxjs';
import { TableComponent } from '../../../../elements.component.module/table.component';
import { NachrichtenService } from '../../../../providers.module/nachrichten.service';
import { NachrichtMetadata } from '../../../../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'posteingang',
    templateUrl: './posteingang.component.html',
    styleUrls: ['../../../commonless/content.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PosteingangComponent extends SuperComponent implements OnDestroy, AfterViewInit {

    @ViewChild('posteingangTable')
    posteingangTable?: TableComponent;

    task?: string;

    currentOffset = 0;

    searchTerm = '';

    currPosteingangNachrichten: NachrichtMetadata[] = [];

    visibleNachrichten: WritableSignal<NachrichtMetadata[]> = signal([]);

    private readonly navigationSubscription: Subscription;

    constructor(
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly state: AppState,
        private readonly nachrichtenService: NachrichtenService
    ) {
        super();

        // Lade Liste neu, wenn man auf die Seite kommt.
        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.reloadList();
            }
        });
    }

    readonly nachrichtMetaData: TableCellDescriptor[] = [
        new TableCellDescriptor(
            '✉',
            'gelesen',
            'gelesen-icon',
            true,
            SortType.NUMERICAL,
            '5%'
        ),
        new TableCellDescriptor(
            'Betreff',
            'betreff',
            'gelesen',
            true,
            SortType.ALPHABETICAL,
            '85%'
        ),
        new TableCellDescriptor(
            'Datum',
            'datum',
            'posteingang-datum',
            true,
            SortType.ALPHABETICAL,
            '10%'
        )
    ];

    readonly filterCellNames: string[] = ['gelesen', 'betreff', 'datum'];

    ngAfterViewInit(): void {
        this.loadList();

        this.activatedRoute.params.subscribe(params => {
            const tmp = params['subPage'];
            if (tmp) {
                this.state.registerForLastUrl();
            } else {
                this.state.storeURL();
            }
        });

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            const task = params['task'];

            if (task) {
                if ('refreshList' === task) {
                    this.reloadList();
                    this.task = null;
                } else {
                    this.task = task;
                }
            } else {
                this.task = null;
            }
        });
    }

    private reloadList() {
        setTimeout(
            () => this.loadList(true),
            200
        );
    }

    private loadList(refreshCache = false) {
        this.nachrichtenService.getPosteingangList(refreshCache)
            .pipe(take(1))
            .subscribe(nachrichtenListe=> {
                this.currPosteingangNachrichten = nachrichtenListe.nachrichten;
                this.visibleNachrichten.set(this.currPosteingangNachrichten);
            });
    }

    ngOnDestroy() {
        this.searchTerm = null;

        if (this.currPosteingangNachrichten) {
            this.currPosteingangNachrichten = [];
        }

        if (this.visibleNachrichten) {
            this.visibleNachrichten.set([]);
        }

        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

    searchMe = (term: string) => {
        this.visibleNachrichten.set(
            FilterFunctions.filterMatrix(this.currPosteingangNachrichten, this.filterCellNames, term)
        );
    };

    pagerAction = (page: number) => {
        this.currentOffset = page;
    };

}
